import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopOnDutyTime(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_duty_time">
      <h2 className="pop_tit">당직 시간 관리</h2>
      <div className="content_container mb_no">
        <table className="com_board_list">
          <colgroup>
            <col width="290" />
            <col width="150" />
            <col width="290" />
            <col width="auto" />
          </colgroup>
          <thead>
            <tr>
              <th>기간</th>
              <th>요일</th>
              <th>시간</th>
              <th>관련 직원</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
              </td>
              <td>
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">평일</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">토요일</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">일요일& 공휴일</label>
                </div>
              </td>
              <td>
                <div className="time_wrap">
                  <select name="" id="" className="select">
                    <option value="">10</option>
                  </select>
                  <select name="" id="" className="select">
                    <option value="">10</option>
                  </select>
                  <span className="divider"> ~ </span>
                  <select name="" id="" className="select">
                    <option value="">10</option>
                  </select>
                  <select name="" id="" className="select">
                    <option value="">10</option>
                  </select>
                </div>
              </td>
              <td>
                <section className="com_board_search">
                  <article className="search full">
                    <input type="search" placeholder="검색할 내용을 입력" className="input type_search" />
                    <button className="com_btn gray ws icon_search"></button>
                  </article>
                </section>
                <div className="multiple_file_wrap">
                  <div className="item">
                    <button className="btn_del_file"></button>
                    <span className="tit">홍길동123</span>
                  </div>
                  <div className="item">
                    <button className="btn_del_file"></button>
                    <span className="tit">홍길동123</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
      <div className="content_container scroll">
        <table className="com_board_list">
          <colgroup>
            <col width="70" />
            <col width="260" />
            <col width="260" />
            <col width="260" />
            <col width="260" />
            <col width="130" />
          </colgroup>
          <thead>
            <tr>
              <th>
                <input type="checkbox" id="chkAll" className="com_chk" />
                <label htmlFor="chkAll"></label>
              </th>
              <th>기간</th>
              <th>요일</th>
              <th>시간</th>
              <th>관련 직원</th>
              <th>수정</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(8)].map((_, idx) => (
              <tr key={idx}>
                <td>
                  <input type="checkbox" id={`chk${idx}`} className="com_chk" />
                  <label htmlFor={`chk${idx}`}></label>
                </td>
                <td>2024, 05, 12 ~ 2025, 07, 12</td>
                <td>일요일& 공휴일</td>
                <td>20:00 ~ 23:00</td>
                <td>홍길동132</td>
                <td>
                  <button className="btn_link com_blue_txt">수정</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="com_btn_wrap bottom">
          <button className="com_btn black xs">선택항목 삭제</button>
        </div>
      </div>
    </Modal>
  );
}

export default PopOnDutyTime;
